import React from 'react';
import { RoundImageSizes } from '../../../store/slices/common-slice';
import { RoundImage } from '..';
import Classnames from 'classnames';

import './animated-spinner.scss';

interface AnimatedSpinnerProps {
    imageUrl?: string;
    icon?: string;
}

export const AnimatedSpinner: React.FC<AnimatedSpinnerProps> = ({ imageUrl, icon }): React.ReactElement => {
    const classes = Classnames('animated-spinner', {
        'animated-spinner--has-image': imageUrl,
        'animated-spinner--has-icon': icon,
        'animated-spinner--empty': !icon && !imageUrl,
    });

    const iconClasses = Classnames('animated-spinner__icon', icon);

    return (
        <article className={classes}>
            <div className="animated-spinner__content">
                <div className="animated-spinner__inner-wrapper">
                    {imageUrl && (
                        <RoundImage
                            imageUrl={imageUrl}
                            size={RoundImageSizes.FULL_WIDTH}
                            testId="animated-spinner-image"
                        />
                    )}
                    {icon && <i data-testid="animated-spinner-icon" className={iconClasses}></i>}
                </div>
                <div data-testid="animated-spinner" className="animated-spinner__spinner-wrapper">
                    <div className="animated-spinner__spinner"></div>
                </div>
            </div>
        </article>
    );
};
